import { FormBase } from "core/components";

export default class FacilityInventoryCountEditForm extends FormBase {
    constructor(hooks) {
        super(hooks);
    }

    setup() {
        return {
            fields: [
                {
                    name: "facilityId",
                    label: "FACILITY_INVENTORY.EDIT.FACILITY_LABEL",
                    placeholder: "FACILITY_INVENTORY.EDIT.FACILITY_PLACEHOLDER",
                    rules: "required|string",
                },
                {
                    name: "countDate",
                    label: "FACILITY_INVENTORY.EDIT.COUNT_DATE_LABEL",
                    placeholder: "FACILITY_INVENTORY.EDIT.COUNT_DATE_PLACEHOLDER",
                    rules: "required",
                },
            ],
        };
    }
}